import React from "react"
import { Link, useTranslation } from "@zestia/gatsby-plugin-react-i18next"

import ChevronDown from "../svg/icons/IconChevronDown"
import PartnerIcon from "@/icons/megamenu/partner.svg"

const NavBarMenuResources = ({ showMenu, setShowMenu }) => {
  const { t } = useTranslation()

  return (
    <div className="menu">
      <Link
        to="/resources/"
        className="nav-bar__btn"
        onClick={e => {
          e.preventDefault()
          setShowMenu()
        }}
      >
        <span>{t("navigation.resources.nav-title")}</span>
        <ChevronDown
          className={`menu-icon ${showMenu ? "menu-icon__rotate" : ""}`}
        />
      </Link>

      <div
        className={`menu__mega-menu ${showMenu ? "menu__mega-menu--open" : ""}`}
      >
        {showMenu && (
          <>
            <div className="menu__mega-menu-container">
              <div className="menu__main grid-3-col">
                <Link
                  to="/support/contact-us/"
                  className="menu__item-link menu__item-link--mobile"
                >
                  <p className="mb-0 menu__item-title menu__item-link--mobile">
                    {t("navigation.resources.resources-9.title")}
                  </p>
                  <p className="menu__item-description mb-6 p--sm">
                    {t("navigation.resources.resources-9.description")}
                  </p>
                </Link>
                <Link to="/support/" className="menu__item-link">
                  <p className="mb-0 menu__item-title">
                    {t("navigation.resources.resources-1.title")}
                  </p>
                  <p className="menu__item-description mb-6 p--sm">
                    {t("navigation.resources.resources-1.description")}
                  </p>
                </Link>

                <Link
                  to="/resources/video/managing-your-data-in-capsule/"
                  className="menu__item-link"
                >
                  <p className="mb-0 menu__item-title">
                    {t("navigation.resources.resources-2.title")}
                  </p>
                  <p className="menu__item-description mb-6 p--sm">
                    {t("navigation.resources.resources-2.description")}
                  </p>
                </Link>

                <Link to="/resources/" className="menu__item-link">
                  <p className="mb-0 menu__item-title">
                    {t("navigation.resources.resources-3.title")}
                  </p>
                  <p className="menu__item-description mb-6 p--sm">
                    {t("navigation.resources.resources-3.description")}
                  </p>
                </Link>

                <Link to="/blog/" className="menu__item-link">
                  <p className="mb-0 menu__item-title">
                    {t("navigation.resources.resources-4.title")}
                  </p>
                  <p className="menu__item-description mb-6 p--sm">
                    {t("navigation.resources.resources-4.description")}
                  </p>
                </Link>

                <Link
                  to="/resources/customer-stories/"
                  className="menu__item-link"
                >
                  <p className="mb-0 menu__item-title">
                    {t("navigation.resources.resources-5.title")}
                  </p>
                  <p className="menu__item-description mb-6 p--sm">
                    {t("navigation.resources.resources-5.description")}
                  </p>
                </Link>

                <Link to="/partner-program/" className="menu__item-link">
                  <p className="mb-0 menu__item-title">
                    {t("navigation.resources.resources-6.title")}
                  </p>
                  <p className="menu__item-description mb-6 p--sm">
                    {t("navigation.resources.resources-6.description")}
                  </p>
                </Link>

                <Link to="/what-is-a-crm/" className="menu__item-link">
                  <p className="mb-0 menu__item-title">
                    {t("navigation.resources.resources-7.title")}
                  </p>
                  <p className="menu__item-description mb-6 p--sm">
                    {t("navigation.resources.resources-7.description")}
                  </p>
                </Link>
                <a
                  href="https://www.youtube.com/@CapsuleCRM/podcasts"
                  className="menu__item-link"
                  target="_blank"
                >
                  <p className="mb-0 menu__item-title">
                    {t("navigation.resources.resources-8.title")}
                  </p>
                  <p className="menu__item-description mb-6 p--sm">
                    {t("navigation.resources.resources-8.description")}
                  </p>
                </a>
              </div>
              <Link to="/partners/" className="menu__aside">
                <PartnerIcon className="menu__aside-title-icon" />
                <p className="mt-10 heading-kicker menu__aside-title text-link text-link--dark">
                  {t("navigation.resources.side-section.title")}
                </p>
                <p className="p--sm">
                  {t("navigation.resources.side-section.description")}
                </p>
              </Link>
            </div>
            <div className="menu__footer">
              <div className="menu__footer-container">
                <div className="menu__footer-links">
                  <a
                    className="text-link text-link--dark text-link--bare menu__footer-link p--sm"
                    href="https://developer.capsulecrm.com/"
                  >
                    {t("navigation.resources.footer-link-1")}
                  </a>

                  <Link
                    className="text-link text-link--dark text-link--bare menu__footer-link p--sm"
                    to="/media/"
                  >
                    {t("navigation.resources.footer-link-2")}
                  </Link>

                  <Link
                    className="text-link text-link--dark text-link--bare menu__footer-link p--sm"
                    to="/support/contact-us/"
                  >
                    {t("navigation.resources.footer-link-3")}
                  </Link>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  )
}

export default NavBarMenuResources
